import { render } from "./OrdersProfitCard.vue?vue&type=template&id=6fdda6cd"
import script from "./OrdersProfitCard.vue?vue&type=script&lang=js"
export * from "./OrdersProfitCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__